export const bookedStatus =
	"Currently no prescription available.";
export const noOrdersStatus =
	"Currently no prescription available.";
export const rejectedStatus =
	"Currently no prescription available.";
export const reviewStatus =
	"There are currently no prescriptions available for viewing. Please check back again once your order has been approved and delivered.";
